import axios from "axios";
import {
  ACCOUNT,
  DETAILS,
  DELIVERY_ADDRESS_ROUTE,
  RELATED_CONTACTS,
  USER,
  UPDATE_USER_INFO,
  SET_DEFAULT_DELIVERY_ADDRESS,
} from "../../../constants/apiLink";

export const apiUpdateAccountDeliveryAddress = async (data) => {
  const url = ACCOUNT + DETAILS;
  return axios.put(url, data).then((result) => {
    return result;
  });
};

export const apiCreateAccountDeliveryAddress = async (address) => {
  address.zipCode = data.zip;
  return axios.post("/api/Addresses", address).then((result) => {
    return result;
  });
};

export const apiUpdateDeliveryAddress = async (address) => {
  const url = USER + UPDATE_USER_INFO;
  return axios.patch(url, address).then((result) => {
    return result;
  });
};

export const apiDeleteDeliveryAddress = async (id) => {
  return axios.delete(`/api/Addresses/${id}`).then((result) => {
    return result;
  });
};

export const apiCreateContact = async (data) => {
  data.zipCode = data.zip;
  return axios.post("/api/Addresses", data).then((result) => {
    return result;
  });
};

export const apiUpdateContact = async (data) => {
  const url = RELATED_CONTACTS;
  return axios.patch(url, data).then((result) => {
    return result;
  });
};

export const apiSetDefaultDeliveryAddress = async (address) => {
  const url = USER + SET_DEFAULT_DELIVERY_ADDRESS + address;
  return axios.patch(url, address).then((result) => {
    return result;
  });
};

export const apiGetAddresses = (location) => {
  const data = {
    userCurrentLatitude: location.lat ? location.lat : null,
    userCurrentLongitude: location.lng ? location.lng : null,
  };
  return axios.get(`/api/Addresses`, { params: data }).then((result) => {
    if (result) {
      if (result.data) {
        return result.data;
      }
    }
    return false;
  });
};
